import { useCallback } from 'react';
import { useUiStore } from '@/store/uiStore.ts';
import { useProjectStore } from '@/store/projectStore.ts';
import { enqueueSendToNative } from '@/bridge/embeddedBridge.ts';
import styles from './AnimaticRegenDialog.module.css';

export function AnimaticRegenDialog() {
  const pending = useUiStore(s => s.animaticRegenPending);
  const clearPending = useUiStore(s => s.clearAnimaticRegenPending);

  const onCancel = useCallback(() => {
    if (pending) {
      useProjectStore.getState().updateShotDuration(pending.shotId, pending.previousDuration, { pushUndo: false });
    }
    clearPending();
  }, [pending, clearPending]);

  const onConfirm = useCallback(() => {
    if (pending) {
      enqueueSendToNative('reloadForAnimaticDuration', {
        shotId: pending.shotId,
        newTotalDuration: pending.newDuration,
      });
    }
    clearPending();
  }, [pending, clearPending]);

  if (!pending) return null;

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.dialog} onClick={e => e.stopPropagation()}>
        <h3 className={styles.title}>Re-render animatic?</h3>
        <p className={styles.message}>
          Changing this shot's duration requires re-rendering the animatic video.
          The timeline will briefly reload.
        </p>
        <div className={styles.buttons}>
          <button className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
          <button className={styles.confirmBtn} onClick={onConfirm}>Re-render</button>
        </div>
      </div>
    </div>
  );
}
